import React from 'react';
import PropTypes from 'prop-types';

export default function SelectIcon(props) {
  return (
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
      <path d="M7.33333 18.2308L6 3L18 11.3077L12.6667 12.6923L17.3333 19.6154L15.3333 21L10.6667 14.0769L7.33333 18.2308Z" fill={props.color || '#202020'}/>
    </svg>
  );
}

SelectIcon.propTypes = {
  color: PropTypes.string
};